import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useMe } from '@/lib/auth';

/**
 * Guards a route behind a portal permission. Admins hold every permission, so
 * this only ever redirects a client_user who lacks it. Rendered inside the
 * authenticated shell, so /me is already resolved.
 */
export function PermissionGate({ permission, children }: { permission: string; children: ReactNode }) {
  const me = useMe();
  if (me.isLoading) return null;
  const permissions = me.data?.portal_permissions ?? [];
  if (!permissions.includes(permission)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
